import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router';

import { Popover, Menu } from 'antd';

import styled from 'styled-components';

import { useLayoutContext } from '@contexts/LayoutContext';
import { useStateValue } from '@contexts/StateProvider';

import ContactCreatorDrawer from '@components/ContactCreator/ContactCreatorDrawer';
import NwIcon from '@components/Gui/NwIcon';

import { HeaderContext } from './NwHeader';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    .add-icon-holder {
        position: relative;
        font-size: 2rem;
        cursor: pointer;

        &.disabled {
            cursor: not-allowed;
            opacity: 0.4;
        }
    }
`;

const HeaderGlobalAddButton = () => {
    const headerContextValues = useContext(HeaderContext);
    const { onCloseEventDrawer, onEventCreated } = headerContextValues;
    const [{ areaContext }] = useStateValue();
    const area = areaContext.area;
    const navigate = useNavigate();

    const layoutContext = useLayoutContext();
    const { isMobile } = layoutContext;
    const [creatorType, setCreatorType] = useState('Model');
    const [creatorDrawer, setCreatorDrawer] = useState(false);

    const [open, setOpen] = useState(false);

    const handleClick = (e) => {
        const creatortype = e.key.substr(4);
        setCreatorType(creatortype);
        setCreatorDrawer(true);
        setOpen(false);
    };

    const closeCreatorDrawer = () => {
        setCreatorDrawer(false);
    };

    const onCustomerCreated = (customer) => {
        if (area === 'accounting') {
            navigate(`/accounting/customer/${customer.ID}`);
        } else {
            navigate(`/customer/${customer.ID}`);
        }
        closeCreatorDrawer();
    };

    const onModelCreated = (ID) => {
        if (area === 'accounting') {
            navigate(`/accounting/model/${ID}`);
        } else {
            navigate(`/model/${ID}`);
        }
        closeCreatorDrawer();
    };

    const onProjectCreated = (ID) => {
        navigate(`/bookings/${ID}`);
        closeCreatorDrawer();
    };

    const menuContent = (
        <Menu
            onClick={handleClick}
            selectedKeys={[]}
            mode="vertical"
            className="add-menu-popover"
            items={[
                {
                    label: <span className="submenu-title-wrapper">contacts</span>,
                    type: 'group',
                    children: [
                        { key: 'add-Model', label: 'Model' },
                        { key: 'add-Client', label: 'Client' },
                        { key: 'add-Agency', label: 'Agency' },
                        { key: 'add-Service', label: 'Service' },
                        { key: 'add-ScoutingModel', label: 'Scouting Model' },
                    ],
                },
                {
                    label: <span className="submenu-title-wrapper">bookings</span>,
                    type: 'group',
                    children: [
                        { key: 'add-Project', label: 'Project' },
                        { key: 'add-Job', label: 'Job' },
                        { key: 'add-Casting', label: 'Casting' },
                    ],
                },
                {
                    label: <span className="submenu-title-wrapper">events</span>,
                    type: 'group',
                    children: [
                        { key: 'add-Travel', label: 'Travel' },
                        { key: 'add-Accommodation', label: 'Accommodation' },
                        { key: 'add-FollowUp', label: 'Activity' },
                        { key: 'add-Meeting', label: 'Meeting' },
                        { key: 'add-Notice', label: 'Notice' },
                        { key: 'add-ToDo', label: 'Task' },
                    ],
                },
            ]}
        />
    );

    return (
        <Wrapper>
            <Popover
                content={menuContent}
                trigger="click"
                placement="bottom"
                overlayClassName={`main-nav-submenu ${isMobile ? 'mobile-main-nav-submenu' : ''}`}
                open={open}
                onOpenChange={setOpen}
            >
                <div className="add-icon-holder">
                    <NwIcon primary icon={byPrefixAndName.fass['plus-circle']} />
                </div>
            </Popover>
            {creatorDrawer && (
                <ContactCreatorDrawer
                    type={creatorType}
                    onCancel={closeCreatorDrawer}
                    onModelCreated={onModelCreated}
                    onCustomerCreated={onCustomerCreated}
                    onProjectCreated={onProjectCreated}
                    onEventCreated={onEventCreated}
                    onCloseEventDrawer={onCloseEventDrawer}
                />
            )}
        </Wrapper>
    );
};

export default HeaderGlobalAddButton;
